<form name="newsletter_footer"
      #form="ngForm"
      method="POST">
    <input-wrap [messages]="{
                    email: ('Valid email is required' | translate),
                    required: ('Valid email is required' | translate),
                }"
                [canShowValidate]="emailRef?.value?.length > 0 && form.submitAttempt"
                ngSkipHydration>
        <div class="p-t-1 p-t-2-s p-b-1 p-b-2-s p-r-2 p-l-2-s"
             [ngClass]="[
                hidePrivacyPolicy ? 'flex flex-middle' : '',
                footerNewsletter ? 'flex flex-column-s flex-column-m p-r-0 p-l-0-s': ''
            ]">
            <input class="input bg-col-w p-t-2 p-t-3-s p-b-2 p-b-3-s p-l p-l-5-s p1 _newsletter-input"
                   [ngClass]="hidePrivacyPolicy ? '' : 'm-t-1-s _input-border'"
                   type="email"
                   name="email"
                   [attr.placeholder]="'Email' | translate"
                   maxlength="100"
                   required
                   validatePatternAsync="email"
                   [(ngModel)]="data.email"
                   [ngModelOptions]="{updateOn: 'blur'}"
                   (keyup)="handleKeyUp($event)"
                   #emailRef>

            @if (isPending) {
            <span class="pos-absolute flex flex-middle flex-justify-center pe-none _loading">
                <i class="icon-loading"
                   aria-hidden="true"></i>
            </span>
            }

            @if (!hidePrivacyPolicy) {
            <checkbox class="newsletter-checkbox checkbox-tick w-12 label block m-l-2 m-l-0-s left-s"
                      style="margin-top: 1.35rem"
                      name="consent"
                      required
                      sl-input="newsletter"
                      [(ngModel)]="data.consent">
                <span class="w-8 w-9-m w-8-s col-w left p2"
                      style="margin-left: 0.275rem"
                      [innerHtml]="termsCopy"></span>
            </checkbox>
            }

            <button class="button no-wrap"
                    [ngClass]="[hidePrivacyPolicy ? 'w-4' : 'w-12-s button-size-1 m-t-3 m-t-4-s p-t p-b', footerNewsletter ? 'w-12-m w-12-s m-t-4-m m-t-4-s' : '']"
                    sl-button="subscribe"
                    cy-subscribeSubmit
                    [action]="status"
                    (click)="submit()">
                <span class="_newsletter-button">{{ctaCopy || 'Sign up' | translate}}</span>
            </button>
        </div>
    </input-wrap>

    <result class="block col-2 p2"
            sl-result="subscribe"
            cy-subscribeResultMessage
            [status]="status"
            [success]="'Your email has been submitted.' | translate" />

    @if (!hidePrivacyPolicy && form.submitAttempt) {
    <span class="col-2 block m-t-2 p2">{{'Please agree to the terms to join' | translate }}</span>
    }
</form>